<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <vx-card title="Scan/Report Analyses">

      <div id="algolia-content-container" class="data-list-container">

        <vs-table ref="table" class="pb-5" :data="cyclopedia.analyses">

          <template slot="thead">
            <vs-th sort-key="id">ID</vs-th>
            <vs-th sort-key="name">Name</vs-th>
          </template>

          <template slot-scope="{data}">
            <tbody v-for="(analysis, indextr) in data" :data="analysis" :key="indextr" @click="goToAnalysisDetail(analysis.id)">
            <vs-tr class="cursor-pointer">

              <vs-td>
                <p class="font-medium truncate">{{ analysis.id }}</p>
              </vs-td>

              <vs-td>
                <p class="font-medium truncate">{{ analysis.name }}</p>
              </vs-td>

            </vs-tr>
            </tbody>
          </template>

        </vs-table>

        <vs-button class="ml-auto" color="primary" type="border" icon="add" @click="showCreateAnalysisDialog">Add New Analysis</vs-button>

      </div>

      <vs-prompt
        @accept="createAnalysis"
        :title="`New ${cyclopediaHelpers.getPreferredName(cyclopedia)} Analysis`"
        :active.sync="showCreateAnalysisDialogFlag">
        <div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input
                class="w-full mb-1"
                label-placeholder="Analysis Name"
                v-model="newAnalysisModel.name"
              />
            </div>
          </div>

        </div>
      </vs-prompt>

    </vx-card>
<!--    <div v-html="jp.toHtml(cyclopedias)"></div>-->
</template>

<script>
  import api from '@/http/api';
  import models from '@/models';
  import jsonPrinter from '@/misc/jsonHtmlPrinter';
  import {cyclopediaHelpers} from '@/models/helpers'

  export default {
    components: {},
    data() {
      return {
        models: models,
        jp: jsonPrinter,
        cyclopediaHelpers: cyclopediaHelpers,
        showCreateAnalysisDialogFlag: false,
        newAnalysisModel: new models.CyclopediaAnalysis(),

      }
    },
    props: {
      cyclopedia: {
        type: models.Cyclopedia(),
        required: true,
        default: () => {
          return new models.Cyclopedia()
        }
      },
    },
    methods: {
      async goToAnalysisDetail(analysisId) {
        this.$router.push(`/content/books/analyses/detail?id=${analysisId}`).catch(() => {
        });
      },
      async createAnalysis() {
        if (this.newAnalysisModel.name === '') {
          this.showCreateCategoryDialog(this.newAnalysisModel);
          this.showNotification(false, 'Name is required');
          return;
        }
        this.$vs.loading();

        let newAnalysis = await api.createNewAnalysis(this.newAnalysisModel);

        this.$vs.loading.close();

        if (newAnalysis !== null && newAnalysis.id > 0) {
          this.goToAnalysisDetail(newAnalysis.id);
        } else {
          this.showNotification(false, 'Error creating analysis');
        }

      },
      showCreateAnalysisDialog(analysis) {
        this.newAnalysisModel = new models.CyclopediaAnalysis(analysis);
        this.newAnalysisModel.cyclopedia_id = this.cyclopedia.id;
        this.showCreateAnalysisDialogFlag = true;
      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    },
  }

</script>


<style lang="scss">

</style>

